import React from 'react';
import WmsInput from './../components/WmsInput/WmsInput.jsx';
import WmsDropdown from './../components/WmsDropdown/WmsDropdown.jsx';
import WmsCollapse from './../components/WmsCollapse/WmsCollapse.jsx';
import * as GlobalService from './../global_services';
import WmsCheckBox from "./../components/WmsCheckBox/WmsCheckBox.jsx";
import WmsMultiDropdown from '../components/WmsMultiDropdown/WmsMultiDropdown.jsx';

export class WarehouseFormCustomizations extends React.Component {
    constructor(props) {
        super(props);

        this.translate = window.translate;

        this.state = {
            CustomLabels: GlobalService.getCustomLabels(),
            Rights: GlobalService.GetRights(),
            facilityCheckboxSmartPack: false,
            Selector: 'Warehouse',
            PartialAllocationRadioSelectionState: false,
            measurementStandardOption: [{
                "name": "Imperial",
                "id": 0
            }, {
                "name": "Metric",
                "id": 1
            }],
            locationFieldOption: [{
                "name": "1",
                "value": 1
            }, {
                "name": "2",
                "value": 2
            }, {
                "name": "3",
                "value": 3
            }, {
                "name": "4",
                "value": 4
            }]
        }
    }

    componentWillReceiveProps(nextprops) {
        // Update "Select All" checkbox state based on selected customers
        if (nextprops.sharedWarehouse && nextprops.sharedWarehouse.CustomerOptions) {
            let countOfSelectedCustomers = nextprops.sharedWarehouse.CustomerOptions.filter(c => c.RequireScanToPack === true).length;
            let totalCountOfCustomers = nextprops.sharedWarehouse.CustomerOptions.length;
            const allSelected = countOfSelectedCustomers > 0 && countOfSelectedCustomers === totalCountOfCustomers;
            this.setState({
                facilityCheckboxSmartPack: allSelected,
            });
        }
    }

    handleMultiSelectCustomerChange = (event) => {
        let propFacility = this.props.sharedWarehouse;
        let objFacility = Object.assign({}, propFacility);
        if (!event) {
            event = [];
        }
        // Convert event array to strings for comparison
        const eventIds = event.map(id => String(id));

        // Create a deep copy with new objects
        let copiedCustomerOptions = objFacility.CustomerOptions.map(customer => ({
            ...customer,
            RequireScanToPack: eventIds.includes(String(customer.CustomerIdentifier.Id))
        }));

        // Update "Select All" checkbox state
        const allSelected = copiedCustomerOptions.every(c => c.RequireScanToPack === true);
        this.setState({ facilityCheckboxSmartPack: allSelected });
        objFacility.CustomerOptions = copiedCustomerOptions;
        this.props.onWarehouseDataset(objFacility);
    }

    handleSelectAllCustomers = (event) => {
        let propFacility = this.props.sharedWarehouse;
        let objFacility = Object.assign({}, propFacility);
        const isChecked = event.target.checked;
        objFacility.CustomerOptions = objFacility.CustomerOptions.map(customer => ({
            ...customer,
            RequireScanToPack: isChecked
        }));
        this.setState({ facilityCheckboxSmartPack: isChecked });
        this.props.onWarehouseDataset(objFacility);
    }

    handleWCustFormChanges = (event) => {
        if (typeof event.target === 'undefined') {
            return false;
        }

        let propFacility = this.props.sharedWarehouse;
        let objFacility = Object.assign({}, propFacility)

        const name = event.target.name;
        const value = event.target.value;

        if (event.target.type === 'checkbox') {
            objFacility[name] = event.target.checked
        } else {
            objFacility[name] = value
        }

        if (name == 'Replenishment' && objFacility.Replenishment == false) {
            objFacility.ReplenishFewestLocations = false
        }
        if (name == 'SmartPackRequireScanToPack' && event.target.checked == false) {
            objFacility.CustomerOptions = objFacility.CustomerOptions.map(customer => ({
                ...customer,
                RequireScanToPack: false
            }));
        }


        this.props.onWarehouseDataset(objFacility);
    }


    render() {
        const renderFacility = this.props.sharedWarehouse;
        return (
            <div id={'CollapseWarehouseCustDetail'} className={"collapseWarehouseTabContent_wrapper"}>
                <WmsCollapse id={'ManageWarehouseCustDetail'} className={"collapseWarehouseTabContent_wrapper"} headerLabel={this.translate('Label_Customizations')} showCollapseText={false} showCollapseIcon={false}  >
                    <div className="inline-elements">
                        <WmsInput
                            id='FuelSurcharge'
                            inputName='FuelSurcharge'
                            wmsSelector={this.state.Selector + 'FuelSurcharge'}
                            onChangeFunc={this.handleWCustFormChanges}
                            label={this.translate('Label_Warehouse_FuelSurcharge')}
                            value={renderFacility.FuelSurcharge} />

                        <WmsInput
                            id='FreightRateLocationCode'
                            inputName='FreightRateLocationCode'
                            wmsSelector={this.state.Selector + 'LocationCode'}
                            onChangeFunc={this.handleWCustFormChanges}
                            label={this.translate('Label_External_Warehouse_Code')}
                            value={renderFacility.FreightRateLocationCode} />


                        <WmsDropdown
                            id="LocationFieldCount"
                            name="LocationFieldCount"
                            label={this.translate('Label_Warehouse_LocationFieldCount')}
                            wmsSelector={this.state.Selector + 'FieldCount'}
                            onChangeFunc={this.handleWCustFormChanges}
                            options={this.state.locationFieldOption}
                            valueField='value'
                            textField='name'
                            value={renderFacility.LocationFieldCount} />

                        <WmsDropdown
                            id="MeasurementSystemDefault"
                            name="MeasurementSystemDefault"
                            label={this.translate('Label_Warehouse_MeasurementSystemDefault')}
                            wmsSelector={this.state.Selector + 'MeasurementSystemDefault'}
                            onChangeFunc={this.handleWCustFormChanges}
                            options={this.state.measurementStandardOption}
                            valueField='id'
                            textField='name'
                            value={renderFacility.MeasurementSystemDefault} />
                    </div>
                    <div className="inline-elements d-flex-col">
                        <WmsCheckBox
                            id={'UsePredefinedLocations'}
                            name={'UsePredefinedLocations'}
                            wmsSelector={this.state.Selector + 'UsePredefinedLocations'}
                            onChangeFunc={this.handleWCustFormChanges}
                            label={this.translate("Label_Warehouse_Use_PredefinedLocations")}
                            checked={renderFacility.UsePredefinedLocations === true}
                            value={renderFacility.UsePredefinedLocations}
                            parentClassName="user-predefined-chk-wrapper"
                        />
                    </div>
                    <div className="inline-elements">
                        <WmsCheckBox
                            id={'PreventPartialOrderManualAllocation'}
                            name={'PreventPartialOrderManualAllocation'}
                            wmsSelector={this.state.Selector + 'PreventPartialOrderManualAllocation'}
                            onChangeFunc={this.handleWCustFormChanges}
                            label={this.translate("Label_Warehouse_Partial_Allocations")}
                            checked={renderFacility.PreventPartialOrderManualAllocation === true}
                            value={renderFacility.PreventPartialOrderManualAllocation}
                        />
                    </div>
                    <div className="smart-pack-require-scan-to-pack-wrapper">
                        <WmsCheckBox
                            id={'SmartPackRequireScanToPack'}
                            name={'SmartPackRequireScanToPack'}
                            wmsSelector={this.state.Selector + 'SmartPackRequireScanToPack'}
                            onChangeFunc={this.handleWCustFormChanges}
                            label={this.translate("Label_SmartPackRequireScanToPack")}
                            checked={renderFacility.SmartPackRequireScanToPack === true}
                            value={renderFacility.SmartPackRequireScanToPack}
                            parentClassName="smart-pack-require-scan-to-pack-chk"
                        />
                        {renderFacility.SmartPackRequireScanToPack === true && (
                            <div className="customer-multi-dropdown-wrapper">
                                <WmsCheckBox
                                    id={'selectAll'}
                                    name={'selectAll'}
                                    wmsSelector={this.state.Selector + 'selectAll'}
                                    onChangeFunc={this.handleSelectAllCustomers}
                                    label={this.translate('Label_Costomer_Select_All')}
                                    value={this.state.facilityCheckboxSmartPack}
                                    checked={this.state.facilityCheckboxSmartPack} />

                                <WmsMultiDropdown
                                    id='MultiSelectCustomer'
                                    name='MultiSelectCustomer'
                                    wmsSelector={this.state.Selector + "CustomerOptions"}
                                    options={renderFacility.CustomerOptions}
                                    valueField='CustomerIdentifier.Id'
                                    value={renderFacility.CustomerOptions ? renderFacility.CustomerOptions.map(c => c.RequireScanToPack === true ? c.CustomerIdentifier.Id : null).filter(Boolean) : []}
                                    textField='CustomerIdentifier.Name'
                                    onChangeFunc={this.handleMultiSelectCustomerChange}
                                    tagTemplate='#:values.length# selected' />
                            </div>
                        )}
                    </div>
                    <div className="inline-elements">
                        <WmsCheckBox
                            id={'CrossCustomerPickEnabled'}
                            name={'CrossCustomerPickEnabled'}
                            wmsSelector={this.state.Selector + 'CrossCustomerPickEnabled'}
                            onChangeFunc={this.handleWCustFormChanges}
                            label={this.translate("Label_Enable_Cross_Customer_Pick_Jobs")}
                            checked={renderFacility.CrossCustomerPickEnabled === true}
                            value={renderFacility.CrossCustomerPickEnabled}
                        />
                    </div>
                </WmsCollapse>
                <WmsCollapse id={'Replenishment'} className={"collapseWarehouse-replenishment-wrapper"} headerLabel={this.translate('Label_Replenishment')} showCollapseText={false} showCollapseIcon={false}  >
                    <div className="inline-elements replenishment-chk-wrapper">
                        <WmsCheckBox
                            id={'FacilityReplenishment'}
                            name={'Replenishment'}
                            wmsSelector={this.state.Selector + 'Replenishment'}
                            onChangeFunc={this.handleWCustFormChanges}
                            label={this.translate("Label_Enable_Replenishment")}
                            checked={renderFacility.Replenishment === true}
                            value={renderFacility.Replenishment}
                        />
                        <div className='replenishment-wrapper'>
                            <WmsCheckBox
                                id={'ReplenishFewestLocations'}
                                name={'ReplenishFewestLocations'}
                                wmsSelector={this.state.Selector + 'ReplenishFewestLocations'}
                                onChangeFunc={this.handleWCustFormChanges}
                                label={this.translate("Label_Replenish_From_Fewest_Location")}
                                checked={renderFacility.ReplenishFewestLocations === true}
                                value={renderFacility.ReplenishFewestLocations}
                                disabled={renderFacility.Replenishment == false}
                                parentClassName="replenishment-fewest-location-chk"
                            />
                        </div>
                    </div>
                </WmsCollapse>
                <WmsCollapse id={'CycleCountSettings'} className={"collapseWarehouse-cycle-count-settings-wrapper"} headerLabel={this.translate('Label_Cycle_Count')} showCollapseText={false} showCollapseIcon={false}  >
                      <div className='per-day-cunt-wrapper'>
                        <WmsInput
                            id='MaxCycleCountsPerDay'
                            inputName='MaxCycleCountsPerDay'
                            wmsSelector={this.state.Selector + 'MaxCycleCountsPerDay'}
                            onChangeFunc={this.handleWCustFormChanges}
                            label={this.translate('Label_Maximum_Number_Of_Audit_Jobs_Per_Day')}
                            value={renderFacility.MaxCycleCountsPerDay}
                            valueType="number"
                        />
                    </div>
                </WmsCollapse>
            </div>
        )
    }
}